import React from 'react'

import { Footer } from '../Footer/Footer'
import { Header } from '../Header'
import { Main } from '../Main'

import { Banner } from './Banner/Banner'
import style from './Layout.module.css'

export const Layout = () => {
  return (
    <div className={style.layout}>
      <Header />
      <Banner />
      <Main />
      <Footer />
    </div>
  )
}
